<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="center-form">
        <h2 class="center-align">Welcome back</h2>
        <b-form>
          <b-form-group id="email" label="Email address" label-for="email">
            <b-form-input
              id="email"
              v-model="form.email.value"
              :state="form.email.error.state"
              type="email"
              placeholder="Enter email address"
              required
            ></b-form-input>
            <b-form-invalid-feedback :state="form.email.error.state">
              {{ form.email.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group id="password" label="Password" label-for="password">
            <b-form-input
              id="password"
              type="password"
              v-model="form.password.value"
              :state="form.password.error.state"
              placeholder="Enter password"
              required
            ></b-form-input>
            <b-form-invalid-feedback :state="form.password.error.state">
              {{ form.password.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>

          <c-button :onClick="onCancel" variant="secondary" class="right-align">Cancel</c-button>
          <c-button :onClick="onSubmit" variant="primary">Log In</c-button>
          <br>
          <span class="success">{{ formSuccess }}</span>
          <span class="failure">{{ formFailure }}</span>
          <br>
          <router-link :to="{ name: 'SignUp'}"><p>Don't have an account? Sign up here</p></router-link >
        </b-form>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import { onLogin } from '../vue-apollo';
  import CButton from '@/components/Button'

  export default {
    name: 'LogIn',
    components: { CButton },
    props: {

    },
    data() {
      return {
        form: {
          email: {
            value: '',
            error: {}
          },
          password: {
            value: '',
            error: {}
          }
        },
        formSuccess: '',
        formFailure: '',
      }
    },
    created() {
      if (this.user && this.user.email) this.$router.push({ name: 'Home' });
    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    methods: {
      async onSubmit(event) {
        for (let key in this.form) {
          this.form[key].error = {}
        }
        this.formSuccess = ''
        this.formFailure = ''

        const body = {
          email: this.form.email.value,
          password: this.form.password.value
        }

        try {
          const result = await this.$http.post(process.env.VUE_APP_API_BASE_URL + "/auth", body);

          this.formSuccess = "Successfully logged in";

          await onLogin.apply(this, [this.$apollo.provider.defaultClient, result.body.user])
          this.$router.push({ name: 'Deployments' });
        } catch(e) {
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
            if (e.body.details) {
              e.body.details.map(detail => {
                detail.path.map(path => {
                  this.$set(this.form[path], 'error', {state: false, value: detail.message})
                })
              })
            }
          }
        }
      },
      onCancel(event) {
        this.$router.push({ name: 'Home' });
      },
    }
  }
</script>

<style scoped>

</style>
